<template>
  <div class="count-choose">
      <button
        class="count count--remove"
        :disabled="!canDecrease"
        @click="$emit('update:value', value - 1)">
      </button>

      <input
        type="number"
        class="count__input" name="input"
        :class="{'none' : value === 0}"
        :value="value"
        @input="$emit('update:value', parseInt($event.target.value))"
        readonly>

      <button
        class="count count--add"
        :disabled="!canIncrease"
        @click="$emit('update:value', value + 1)">
      </button>
  </div>
</template>

<script>
export default {
  name: 'CiCounter',
  props: {
    value: {
      type: Number,
      required: true,
    },
    canDecrease: {
      type: Boolean,
      default: true,
    },
    canIncrease: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.count-choose {
  display: flex;
}

.count {
  -moz-appearance: none;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  -webkit-font-smoothing: inherit;
  background: white;
  border-radius: 50%;
  border: none;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: flex;
  height: 39px;
  justify-content: center;
  padding: 0;
  width: 39px;
}

.count__input {
  @include font('gotham_mediumregular');
  @include font-format(1.375rem, 26px);

  width: 60px;
  border: 0;
  margin: 0 1px;
  text-align: center;
  background: transparent;

  &.none {
    color: #9b9b9b;
  }

  &:focus {
    outline: none;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.count--add {
  position: relative;

  &::after {
    background: $primary-green;
    content: '';
    height: 13px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3px;
  }
  &::before {
    background: $primary-green;
    content: '';
    height: 3px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 13px;
  }
}

.count--remove {
  position: relative;

  &::before {
    background: $primary-green;
    content: '';
    height: 3px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 13px;
  }
}

.count[disabled] {
  cursor: not-allowed;
  &::after,
  &::before {
    background: #9b9b9b;
  }
}
</style>
